<template>
    <div data-backdrop="static" data-keyboard="false" class="modal fade" id="carrier-form-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title page-title" v-html="modalTitle"/>
                </div>
                <form @submit.prevent="submit()" class="form-horizontal">
                    <div class="modal-body">
                        <div class="form-group row">
                            <label for="carrier-name" class="col-2 control-label">
                                <span v-html="$t('CarrierFormModal.name')"/>
                                <RedAsterisk/>
                            </label>
                            <div class="col-10">
                                <input id="carrier-name" :placeholder="$t('CarrierFormModal.required')" type="text" ref="nameInput"
                                       class="form-control" required v-model="carrier.name"/>
                            </div>
                        </div>
                        <div v-if="!carrier.id" class="form-group row">
                            <label class="col-12 control-label text-center mb-3">
                                <span v-html="$t('CarrierFormModal.chargesBy')"/>
                                <RedAsterisk/>
                            </label>
                            <div class="col-12 d-flex justify-content-around">
                                <div v-tooltip="$t('CarrierFormModal.carrierChargesByWeight')"
                                     class="radio radio-inline radio-info form-check form-check-inline mr-0">
                                    <input class="form-check-input" type="radio" v-model="carrier.chargesBy"
                                           id="charges-by-weight" value="weight" name="chargesBy" required>
                                    <label class="form-check-label" for="charges-by-weight">
                                        <span v-html="$t('CarrierFormModal.weight')"/>
                                        <i class="fas fa-weight-hanging text-info ml-1"/>
                                    </label>
                                </div>
                                <div v-tooltip="$t('CarrierFormModal.carrierChargesByLot')"
                                     class="radio radio-inline radio-warning form-check form-check-inline mr-0">
                                    <input class="form-check-input" type="radio" v-model="carrier.chargesBy"
                                           id="charges-by-lot" value="lot" name="chargesBy">
                                    <label class="form-check-label" for="charges-by-lot">
                                        <span v-html="$t('CarrierFormModal.lot')"/>
                                        <i class="fas fa-box text-warning ml-1"/>
                                    </label>
                                </div>
                                <div v-tooltip="$t('CarrierFormModal.carrierChargesByQuantity')"
                                     class="radio radio-inline radio-success form-check form-check-inline mr-0">
                                    <input class="form-check-input" type="radio" v-model="carrier.chargesBy"
                                           id="charges-by-quantity" value="quantity" name="chargesBy">
                                    <label class="form-check-label" for="charges-by-quantity">
                                        <span v-html="$t('CarrierFormModal.quantity')"/>
                                        <i class="fas fa-sort-numeric-up-alt text-success ml-1"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <transition name="fade-in">
                            <div v-if="carrier.chargesBy === 'weight'" class="form-group row align-items-center">
                                <label for="max-weight" class="col-2 control-label" v-html="$t('CarrierFormModal.maxWeight')"/>
                                <div class="col-10">
                                    <div class="input-group">
                                        <input id="max-weight" :placeholder="$t('CarrierFormModal.optional')" min="1"
                                               type="number" class="form-control" v-model="carrier.maxWeight"/>
                                        <div class="input-group-append">
                                            <span class="input-group-text" v-html="'g'"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                        <hr/>
                        <div class="form-group row">
                            <label class="col-6 control-label" v-html="$t('CarrierFormModal.enabledForProduction')"/>
                            <label class="col-6 control-label" v-html="$t('CarrierFormModal.enabledForDistribution')"/>
                            <div class="col-6">
                                <toggle-button :value="carrier.enabledForProduction" :sync="true" v-model="carrier.enabledForProduction"/>
                            </div>
                            <div class="col-6">
                                <toggle-button :value="carrier.enabledForDistribution" :sync="true" v-model="carrier.enabledForDistribution"/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-6 control-label">
                                <span v-html="$t('CarrierFormModal.needsGLN')"/>
                                <InfoCircle :tooltip="$t('CarrierFormModal.whatIsGLN')"/>
                            </label>
                            <label class="col-6 control-label">
                                <span v-html="$t('CarrierFormModal.private')"/>
                                <InfoCircle :tooltip="$t('CarrierFormModal.whatIsPrivate')"/>
                            </label>
                            <div class="col-6">
                                <toggle-button :value="carrier.needsGLN" :sync="true" v-model="carrier.needsGLN"/>
                            </div>
                            <div class="col-6">
                                <toggle-button :value="carrier.private" :sync="true" v-model="carrier.private"/>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer flex justify-content-between">
                        <button :disabled="loading" type="button" class="btn btn-secondary" data-dismiss="modal" v-html="$t('CarrierFormModal.close')"/>
                        <SubmitBtn classes="btn btn-primary" :text="modalMainAction" :loading="loading"/>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Carrier from "../../../../classes/Billing/Carrier/Carrier";
import SubmitBtn from "../../forms/SubmitBtn";
import RedAsterisk from "../../forms/RedAsterisk";
import InfoCircle from "../../misc/InfoCircle";

export default {
    name: "CarrierFormModal",
    components: {InfoCircle, RedAsterisk, SubmitBtn},
    data() {
        return {
            loading: false,
            carrier: new Carrier(),
            mode: "create",
        };
    },
    computed: {
        modalTitle() {
            return this.mode === "create" ? this.$t("CarrierFormModal.addCarrier") : this.$t("CarrierFormModal.editCarrier");
        },
        modalMainAction() {
            return this.mode === "create" ? this.$t("CarrierFormModal.add") : this.$t("CarrierFormModal.edit");
        },
    },
    methods: {
        show(carrier = null) {
            this.mode = carrier === null ? "create" : "edit";
            this.carrier = new Carrier(carrier);
            // eslint-disable-next-line no-undef
            $("#carrier-form-modal").modal("show");
            if (this.mode === "create") {
                setTimeout(() => this.$refs.nameInput.focus(), 500);
            }
        },
        async submit() {
            this.carrier.sanitizeForAPI();
            try {
                this.loading = true;
                if (this.mode === "create") {
                    await this.submitCreate();
                } else if (this.mode === "edit") {
                    await this.submitEdit();
                }
            } catch (e) {
                this.$displayError(e);
            } finally {
                this.loading = false;
            }
        },
        async submitCreate() {
            const response = await this.$diceAPI.postCarrier(this.carrier);
            this.$emit("addCarrier", response.data);
            // eslint-disable-next-line no-undef
            $("#carrier-form-modal").modal("hide");
            this.$toasted.success(this.$t("CarrierFormModal.carrierAdded"), { icon: "check" });
        },
        async submitEdit() {
            const response = await this.$diceAPI.patchCarrier(this.carrier);
            this.$emit("editCarrier", response.data);
            // eslint-disable-next-line no-undef
            $("#carrier-form-modal").modal("hide");
            this.$toasted.success(this.$t("CarrierFormModal.carrierEdited"), { icon: "check" });
        },
    },
};
</script>

<style scoped>

</style>